const ZEKTEC_WEBSITE = "https://zektec.com";
const BLOG_WEBSITE = "https://blog.version2.io";
const DOCS_WEBSITE = "https://docs.version2.io";
const STATUS_WEBSITE = "https://status.version2.io/";
const SUGGESTIONS_FORM =
  "https://portal.zektec.com/embed/form/nXikqKkEWoksWNHvq";

const HI_EMAIL = "hi@version2.io";
const SUPPORT_EMAIL = "support@version2.io";

const links = {
  ZEKTEC_WEBSITE,
  BLOG_WEBSITE,
  DOCS_WEBSITE,
  STATUS_WEBSITE,
  SUGGESTIONS_FORM,
  HI_EMAIL,
  SUPPORT_EMAIL,
};

export default links;
